import type { TeamPlayerFinderRegistration } from '../types'

const startTime = (entry: TeamPlayerFinderRegistration): number => {
  const startsAt = entry.competition?.starts_at
  const time = startsAt ? Date.parse(startsAt) : Number.NaN

  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time
}

/**
 * Which registration the Player Finder sub-tab opens on.
 *
 *  - the PREFERRED one (a link from the Team Budget sheet, or the rep's last pick)
 *    when the caller can still see it;
 *  - otherwise the most recent competition — the season a rep is most likely
 *    recruiting for. Undated competitions sort last, and ties keep the server's
 *    order, so the choice is stable across refetches;
 *  - null when there is nothing to manage.
 */
export const pickDefaultPlayerFinderRegistration = (
  registrations: readonly TeamPlayerFinderRegistration[],
  preferredId?: string | null
): TeamPlayerFinderRegistration | null => {
  if (registrations.length === 0) {
    return null
  }

  if (preferredId) {
    const preferred = registrations.find((entry) => entry.id === preferredId)
    if (preferred) {
      return preferred
    }
  }

  return registrations.reduce((latest, entry) =>
    startTime(entry) > startTime(latest) ? entry : latest
  )
}
